/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Chat_IntroInputs */

const en_us2_clubs_chat_intro = /** @type {(inputs: Clubs_Chat_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short messages, kept for 30 days.`)
};

const pt_br2_clubs_chat_intro = /** @type {(inputs: Clubs_Chat_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagens curtas, guardadas por 30 dias.`)
};

const es_419_clubs_chat_intro = /** @type {(inputs: Clubs_Chat_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensajes cortos, guardados por 30 días.`)
};

const pt_pt2_clubs_chat_intro = /** @type {(inputs: Clubs_Chat_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagens curtas, guardadas durante 30 dias.`)
};

const fr_fr2_clubs_chat_intro = /** @type {(inputs: Clubs_Chat_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages courts, conservés 30 jours.`)
};

const de_de2_clubs_chat_intro = /** @type {(inputs: Clubs_Chat_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurze Nachrichten, 30 Tage gespeichert.`)
};

const it_it2_clubs_chat_intro = /** @type {(inputs: Clubs_Chat_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggi brevi, conservati per 30 giorni.`)
};

/**
* | output |
* | --- |
* | "Short messages, kept for 30 days." |
*
* @param {Clubs_Chat_IntroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_chat_intro = /** @type {((inputs?: Clubs_Chat_IntroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Chat_IntroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_chat_intro(inputs)
	if (locale === "es-419") return es_419_clubs_chat_intro(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_chat_intro(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_chat_intro(inputs)
	if (locale === "de-DE") return de_de2_clubs_chat_intro(inputs)
	if (locale === "it-IT") return it_it2_clubs_chat_intro(inputs)
	return en_us2_clubs_chat_intro(inputs)
});
export { clubs_chat_intro as "clubs.chat_intro" }